export default class RequestError<DataType> extends Error {
  constructor(message: string, public readonly responseStatus: number, public readonly data: DataType) {
    super(message);
  }

  public toJson(): { message: string; responseStatus: number; data: DataType } {
    return { message: this.message, responseStatus: this.responseStatus, data: this.data };
  }
}
